
    import { Component, Prop } from 'vue-property-decorator';
    import { Notification, RegisterReview } from '@/api/model/interfaces';
    import * as Odata from '@/api/odata';
    import NotificationItem from '@/components/common/notification-item.vue';

    @Component
    export default class RegisterReviewNew extends NotificationItem {
        @Prop({ required: true })
        notification!: Notification;

        review: RegisterReview | null = null;

        async mounted() {
            this.review = await Odata.RegisterReview.setParams({
                expand: [ 'Reviewer($expand=ReviewedEntity)' ],
            }).getById(this.notification.EntityId.toString());
            this.link = this.review.Reviewer?.ReviewedEntity
                ? `/asbuilt/registers/${this.review.Reviewer.ReviewedEntity.Id}`
                : null;
        }
    }
